import React from 'react';
import { useUID } from 'react-uid';

const Select = ({ children, label = '', ...selectProps }) => {
  const uid = useUID();
  return (
    <div className="select-wrapper">
      {label.length > 0 && <label htmlFor={uid}>{label}</label>}
      <select id={uid} {...selectProps}>
        {children}
      </select>
    </div>
  );
};

export default Select;
